// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b6731556","706":"f5eb1221"}[chunkId] + ".chunk.js";
};